import { render } from "./TextareaVariables.vue?vue&type=template&id=1810fdd6&scoped=true"
import script from "./TextareaVariables.vue?vue&type=script&lang=ts"
export * from "./TextareaVariables.vue?vue&type=script&lang=ts"

import "./TextareaVariables.vue?vue&type=style&index=0&id=1810fdd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1810fdd6"

export default script